import styled from 'styled-components';

import { CHART_TITLE_COLOR, CHART_SUBTITLE_COLOR } from '../../../utils/colors';
import { sansSerifFont } from '../../layout/layout.styles';
import { getSize } from '../charts.helper';
import { media } from '../../../utils/media';
import { ShareButton as ShareButtonComponent } from '../../shareButton';

export const Wrapper = styled.div`
  margin-right: 30px;
  margin-left: 30px;
  padding: 15px 0 20px;
  border-top: 2px solid ${CHART_TITLE_COLOR};

  ${media.tablet`
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

export const TitlesWrapper = styled.div`
  ${sansSerifFont};
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 15px;
  width: 100%;

  ${media.tablet`
    width: 60%;
    margin-bottom: 0;
    margin-left: ${getSize('xOffset')};
  `}
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 0.9em;
  line-height: 1.2em;
  color: ${CHART_TITLE_COLOR};
  text-transform: uppercase;
`;

export const Subtitle = styled.div`
  font-size: 0.7em;
  color: ${CHART_SUBTITLE_COLOR};
`;

export const ShareButton = styled(ShareButtonComponent)`
  align-self: flex-start;

  svg {
    height: 30px;
    width: 30px;
  }

  ${media.tablet`
    margin-right: 20px;
  `}
`;

export const ChildrenWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TitleAndShareWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;
